<template>
  <div class="chat-date">
    <p class="small dim">{{ dayjs(message.sentAt).locale('en').format('ddd MMM DD YYYY') }}</p>
  </div>
</template>

<script setup lang="ts">
import dayjs from '@/plugins/dayjs';
import { ChatMessage } from '@/types/socket';

const { message } = defineProps<{
  message: ChatMessage;
}>();
</script>

<style scoped lang="scss">
.chat-date {
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
</style>
